export default "__VITE_PUBLIC_ASSET__d6771522__"